import { create } from 'zustand';
import { getTripAnalysisKey } from '../../utils/tripAnalysis';

export const useTripAnalysisSubscriptionStore = create((set) => ({

    subscriptions: new Map(),

    syncSubscriptions: (trips = []) => {

        const subscriptions = new Map();

        for (const trip of trips) {

            const date = trip.DATA_REFERENCIA;
            const codigo = trip.CODIGO_INTEGRACAO;

            if (!date || !codigo) {
                continue;
            }

            const key = getTripAnalysisKey(date, codigo);

            subscriptions.set(key, {
                date,
                codigo
            });

        }

        set({
            subscriptions
        });

    },

    clearSubscriptions: () => {

        set({
            subscriptions: new Map()
        });

    }

}));